import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'

import Dropdown from '../../../components/dropdown'
import { parseLocation, makeLink } from '../../../../common/utils/urlHelper'
import { commaStyleString } from '../../../../common/utils/formatString'
import siteConfig from '../../../../common/utils/siteConfig'
import SortByDropdown from './sortByDropdown'
import MuteSwitcher from './muteSwitcher'

const dateFilterLabels = [
  'Any date',
  'In the last year',
  'In the last month',
  'In the last week',
  'In the last day'
]

const SearchResultHeader = ({
  currentSite,
  location,
  date,
  preferences,
  history,
  setUserVideoPlayerStatus
}) => {
  const view = preferences.searchResultsViewType
  const muted = preferences.searchVideoMuted

  const { query } = location
  const parsedLocation = parseLocation(location)
  const itemViews = siteConfig(currentSite, 'ui.item_list_views') || []
  const shouldShowVideoMuteSwitcher = currentSite === 'videohive'

  const onMute = () => setUserVideoPlayerStatus(true)
  const onUnmute = () => setUserVideoPlayerStatus(false)

  const onDateSelectionChange = (event) => {
    let date = event.target.value

    let newQuery = Object.assign({}, parsedLocation, {
      date
    })

    delete newQuery.page

    if (newQuery.date === '') {
      delete newQuery.date
    }

    history.push(makeLink(newQuery))
  }

  const getSelectDateDefaultValue = () => {
    return parsedLocation.date || ''
  }

  const renderDateFilter = () => {
    // append the top level options
    const dates = [{
      count: null,
      description: null,
      key: ''
    }, ...date]

    const selectedDateFilterIndex = dates.map(d => d.key).indexOf(query.date || '')
    // build the date options
    const dateFilterOptions = dates.map((d, index) => {
      /**
       * The label will choose whether to show count based on the current selected date
       * if it's filtered by year, it will show all the count
       * if it's filtered by month, it will not show year count but all the others
       * same rule applies to week/day
       */
      let label = (d.count && index >= selectedDateFilterIndex)
        ? `${dateFilterLabels[index]} - ${commaStyleString(d.count)}`
        : dateFilterLabels[index]
      label = index === selectedDateFilterIndex ? `Added: ${label}` : label
      return {
        value: d.key,
        label
      }
    })

    return (
      <div className='inline-select-wrapper -hide-phone'>
        <div className='search-facet-header--horizontal'>
          <h2>
            <i className='e-icon -icon-calendar -margin-right' />
            <span className='e-icon__alt'>Added</span>
          </h2>
        </div>
        <div className='-border-top-none -border-radius-none inline-select'>
          <label htmlFor='date' className='fds-u-is-visually-hidden'>Added</label>
          <Dropdown
            name='date'
            options={dateFilterOptions}
            onChange={onDateSelectionChange}
            value={getSelectDateDefaultValue()} />
        </div>
      </div>
    )
  }

  const renderLayoutSwitcher = () => {
    return (
      <div className='search-facet-layout-switcher'>
        <div className='btn-group'>
          {itemViews.map((availableView, index) => {
            const nextQuery = Object.assign({}, parsedLocation, {
              view: availableView.value
            })
            const className = classNames('btn-search-switch', {
              'is-active': view === availableView.value
            })
            return (
              <Link to={makeLink(nextQuery)} className={className} key={index}>
                <i className={`e-icon -icon-${availableView.value}`}>
                  <span className='e-icon__alt'>{availableView.label}</span>
                </i>
              </Link>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className='fds-u-is-hidden--no-js search-facet-horizontal-form' id='search-result-header'>
      <SortByDropdown
        location={location}
        currentSite={currentSite}
      />
      {renderDateFilter()}
      {itemViews.length > 1 && renderLayoutSwitcher()}
      { shouldShowVideoMuteSwitcher &&
        <div className='fds-u-diplay-inlineblock fds-u-pull-right fds-c-text-body -size-xs -weight-bold fds-u-mt1'>
          <MuteSwitcher
            muted={muted}
            onMute={onMute}
            onUnmute={onUnmute}
          />
        </div>
      }
    </div>
  )
}

SearchResultHeader.propTypes = {
  location: PropTypes.object.isRequired,
  date: PropTypes.array,
  view: PropTypes.string,
  preferences: PropTypes.object
}

SearchResultHeader.defaultProps = {
  date: []
}

export const SearchResultHeaderComponent = SearchResultHeader
export default withRouter(SearchResultHeader)



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultHeader.js